import { useNetworkContext, NetworkState } from '@/contexts/NetworkContext';

export type { NetworkState as NetworkConnectionState };

export const useNetworkConnection = (): NetworkState => {
  return useNetworkContext();
};
